module.exports = __webpack_public_path__ + "img/truck.436bd076.png";